import { Component, h, Prop, Event, EventEmitter, Element } from "@stencil/core";
@Component({
	tag: "smart-button",
	styleUrl: "smart-button.scss",
	shadow: true
})

export class SmartButton {
	@Prop() theme: "primary" | "secondary" | "red" = "primary";
	@Prop({reflect: true}) disabled = false;
	@Prop() icon: "left" | "right" = undefined;
	@Prop() type: "submit" | "reset" | "button" | "link" = "button";

	@Prop({ reflect: true }) href?: string;
	/**
   * The `target` attributed can be used in conjunction with the `href` attribute.
   * See [mdn docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target)
   * for more information on the `target` attribute.
   */
  @Prop() target?: "_blank" | "_self" | "_parent" | "_top";
	
	@Event() buttonClick: EventEmitter<MouseEvent>;
	@Element() el: HTMLSmartButtonElement;

	private handleClick(e: MouseEvent){
		e.preventDefault();
		const form = this.el.closest("form");
		if (this.type === "submit" && form) {
			e.preventDefault();
			const fakeSubmit = document.createElement("button");
			fakeSubmit.type = "submit";
			fakeSubmit.style.display = "none";
			form.appendChild(fakeSubmit);
			fakeSubmit.click();
			fakeSubmit.remove();
		}
		this.buttonClick.emit(e);
	}

	render() {
		const hasIcon = (this.icon === "left" || this.icon === "right") && this.theme !== "red";

		if(this.type === "link") {
			const iconClass = hasIcon ? `link--${this.icon}` : "";
			return (
				<a href={this.href} class={`link ${this.theme} ${iconClass}`} target={this.target}>
					{hasIcon && (
						<smart-icon 
							color='rgba(1, 1, 20, 0.88)' 
							phosphorIcon={`ph-caret-${this.icon}`} 
							weight="bold" 
							size={22}
						/>
					)}
					<span class='text'>
						<slot></slot>
					</span>
				</a>
			);
		}
	
		return (
			<button 
				role="button" 
				part="button-element" 
				class={this.theme} 
				disabled={this.disabled} 
				onClick={this.handleClick.bind(this)} 
				type={this.type}
			>
				{hasIcon ?
					<div class={this.icon}>
						<smart-icon 
							color='rgba(1, 1, 20, 0.88)' 
							phosphorIcon={`ph-caret-${this.icon}`} 
							weight="bold" 
							size={22} 
							style={{"flex": "0.5", "justify-content": this.icon}}/>
						<slot></slot>
					</div>
					:
					<slot></slot>}
			</button>
		);
	}
}
